import { useState } from "react";
import axios from "axios";

function useDeleteMatch() {
  const [loading, setLoading] = useState(false);

  const deleteMatch = async (id, matchData) => {
    try {
      setLoading(true);
      const DEL_MATCH_URL =
        process.env.REACT_APP_URL_API + "/api/soccer-matchs/" + id;
      const teamResponse = await axios.delete(DEL_MATCH_URL, matchData);
      return teamResponse?.data?.message;
    } catch (e) {
      console.log(e?.response?.message);
      return e?.response?.message;
    } finally {
      setLoading(false);
    }
  };

  return { loading, deleteMatch };
}

export default useDeleteMatch;
